import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum JobTemplateSecurityRight {
    CanAccess = 22000,
    Manage = 22001,
}

export class JobTemplatesSecurityModule extends BaseSecurityModule<JobTemplateSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.JobTemplates,
            [
                { _id: JobTemplateSecurityRight.CanAccess, name: 'Access', basic: true, subscription: TenantSubscription.Professional },
                { _id: JobTemplateSecurityRight.Manage, name: 'Manage', basic: true, subscription: TenantSubscription.Professional },
            ] as SecurityRight<JobTemplateSecurityRight>[]
        );

        this.plan = TenantSubscription.Professional;
    }


}
